import { render, staticRenderFns } from "./ReportStudentDis.vue?vue&type=template&id=9a29b06c"
import script from "./ReportStudentDis.vue?vue&type=script&lang=js"
export * from "./ReportStudentDis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports